import fetchClient from "api/client";
import TAGS_ENDPOINT from "./tagsEndpoint";
/**
 * @description GET api/tags
 * */
export default async function getTags({ queryKey: [,], signal }) {
  return fetchClient.get(`${TAGS_ENDPOINT}`, {
    signal,
  });
}
